// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/bonusprogram-" + chunkId + "." + {"1":"6fa4093a","2":"36e68ff9","3":"d0013b6b","4":"e24a469c","5":"bc4b6e0a","6":"f7896a51","7":"ca69cff4","8":"4505f32d"}[chunkId] + ".js";
};